import Api from './api'
import Url from './request.url'

export default class ServiceAdminApi extends Api {

  constructor() {
    super()
  }

  getGuage() {
    return new Promise(resolve => {
      this.axios().get(Url.service.admin.getGuage).then(res => {
        resolve(res.data)
      })
    })
  }
  updGuage(params) {
    return this.axios().post(Url.service.admin.updGuage, params).then(res => res.data)
  }

  getBody() {
    return new Promise(resolve => {
      this.axios().get(Url.service.admin.getBody).then(res => {
        resolve(res.data)
      })
    })
  }
  updBody(params) {
    return this.axios().post(Url.service.admin.updBody, params).then(res => res.data)
  }

  getTriangle() {
    return new Promise(resolve => {
      this.axios().get(Url.service.admin.getTriangle).then(res => {
        resolve(res.data)
      })
    })
  }
  updTriangle(params) {
    return this.axios().post(Url.service.admin.updTriangle, params).then(res => res.data)
  }

  getInjury() {
    return new Promise(resolve => {
      this.axios().get(Url.service.admin.getInjury).then(res => {
        resolve(res.data)
      })
    })
  }
  updInjury(params) {
    return this.axios().post(Url.service.admin.updInjury, params).then(res => res.data)
  }
}

